export enum AgentStatus {
  RUNNING = 'running',
  STOPPED = 'stopped',
  STOP_FAILED = 'stop_failed',
  START_FAILED = 'start_failed'
}